import Axios, { AxiosResponse } from "axios";
import defineHeaderAxios from "@/utilities/useAuthToken";
import UserSettingsViewModel from "@/models/UserSettingsViewModel";
export default function () {
    const updateUserSettings = async (
        model: UserSettingsViewModel
    ): Promise<void> => {
        await defineHeaderAxios();
        return new Promise((resolve, reject) => {
            Axios.put("api/userSettings", model)
                .then((result: AxiosResponse) => {
                    if (result.status === 200) {
                        resolve();
                    } else {
                        reject();
                    }
                })
                .catch((error) => {
                    console.log(error);
                    reject();
                });
        });
    };

    const getUserSettings = async (): Promise<UserSettingsViewModel> => {
        await defineHeaderAxios();
        return new Promise((resolve, reject) => {
            Axios.get(`/api/userSettings`)
                .then((result: AxiosResponse<UserSettingsViewModel>) => {
                    if (result.status === 200) {
                        resolve(result.data);
                    } else {
                        reject();
                    }
                })
                .catch((error) => {
                    console.log(error);
                    reject();
                });
        });
    };
    return {
        updateUserSettings,
        getUserSettings,
    };
}
